import React, { useState, useEffect, useRef } from 'react';
import '../css/header.css';
import { navLinks } from '../data';
import ThemeToggle from './ThemeToggle';

export default function Header() {
  const [activeLink, setActiveLink] = useState('');
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const sections = useRef([]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setScrolled(scrollTop > 50);
    };

    window.addEventListener('scroll', handleScroll);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveLink(entry.target.id);
          }
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );

    sections.current = navLinks.map(link => document.querySelector(link.href));
    sections.current.forEach((section) => {
      if (section) {
        observer.observe(section);
      }
    });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      sections.current.forEach((section) => {
        if (section) {
          observer.unobserve(section);
        }
      });
    };
  }, []);

  const handleLinkClick = (link) => {
    setActiveLink(link);
    setIsNavOpen(false);
  };

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  return (
    <header>
      <a href="#main" className="skip-to-main">
        Skip to main content
      </a>
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`} role="navigation" aria-label="Main navigation">
        <div className="logo">
          <a href="#"><img className="logoImg" src="/images/logo.png" alt="Ghyas Ali - Frontend Developer" /></a>
        </div>
        <ul className={`nav-list ${isNavOpen ? 'active' : ''}`}>
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className={activeLink === link.href.substring(1) ? 'active' : ''}
                onClick={() => handleLinkClick(link.href.substring(1))}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>
        <ThemeToggle />

        <button
          className={`burger ${isNavOpen ? 'active' : ''}`}
          onClick={toggleNav}
          aria-label="Toggle navigation menu"
          aria-expanded={isNavOpen}
        >
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
        </button>
      </nav>
    </header>
  );
}
